import { render, staticRenderFns } from "./HighlightableText.vue?vue&type=template&id=3347f0f1&"
import script from "./HighlightableText.vue?vue&type=script&lang=js&"
export * from "./HighlightableText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports